import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionRanking from './components/SectionRanking';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionFaq from './components/SectionFaq';
import SectionFeatures from './components/SectionFeatures';
import SectionApp from './components/SectionApp';
import SectionCarousel from './components/SectionCarousel';
import SectionComments from './components/SectionComments';
import SectionCards from './components/SectionCards';
import SectionMedia from './components/SectionMedia';
import SectionAbout from './components/SectionAbout';
import SectionContact from './components/SectionContact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionRanking />
        <SectionUpdates />
        <SectionTopics />
        <SectionFaq />
        <SectionFeatures />
        <SectionApp />
        <SectionCarousel />
        <SectionComments />
        <SectionCards />
        <SectionMedia />
        <SectionAbout />
        <SectionContact />
      </main>
      <Footer />
    </div>
  );
}